<template>
	<div class="sidebar">
		<!-- 蓝色背景底 + 渐变覆盖层叠加 -->
		<div class="sidebar-bg-layer">
			<div class="sidebar-solid"></div>
			<el-image class="sidebar-overlay" :src="require('@/static/CodeBuddyAssets/32497_2995/1.png')"></el-image>
		</div>
		<!-- 主内容区：Flex 纵向排列 -->
		<div class="sidebar-content">
			<!-- Logo -->
			<div class="logo-area" @click="link('/indexHome')">
				<div class="logo-base"></div>
				<el-image class="logo-img" :src="require('@/static/add2/logo1.png')"></el-image>
			</div>
			<!-- 导航菜单列表 -->
			<ul class="menu-list">
				<li v-for="(item,index) in menuItems" :key="index" class="menu-item f-ct"
					:class="menuItemsIdx==index?'a':''" @click="handleMenuClick(item, index)">
					<el-image class="menu-icon" v-show="menuItemsIdx == index" :src="item.iconH"></el-image>
					<el-image class="menu-icon" v-show="menuItemsIdx != index" :src="item.icon"></el-image>
					<span class="menu-text" v-if="index==0">{{ $t('userPageL.txt1') }}</span>
					<span class="menu-text" v-if="index==1">{{ $t('userPageL.txt2') }}</span>
					<span class="menu-text" v-if="index==2">仓库</span>
					<span class="menu-text" v-if="index==3">{{ $t('userPageL.txt3') }}</span>
					<span class="menu-text" v-if="index==4">{{ $t('userPageL.txt4') }}</span>
					<span class="menu-text" v-if="index==5">{{ $t('userPageL.txt5') }}</span>
					<span class="menu-text" v-if="index==6">{{ $t('userPageL.txt6') }}</span>
					<span class="menu-text" v-if="index==7">{{ $t('userPageL.txt7') }}</span>
					<span class="menu-text" v-if="index==8">{{ $t('userPageL.txt9') }}</span>
					<span class="menu-text" v-if="index==9">{{ $t('userPageL.txt10') }}</span>
					<span class="menu-text" v-if="index==10">{{ $t('userPageL.txt11') }}</span>
					<span class="menu-text" v-if="index==11">{{ $t('userPageL.txt12') }}</span>
					<span class="menu-text" v-if="index==12">{{ $t('userPageL.txt13') }}</span>
					<span class="menu-text" v-if="index==13">{{ $t('userPageL.txt14') }}</span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'UserPageSidebar',
		data() {
			return {
				menuItemsIdx: 0,
				menuItems: [{
						label: '首页',
						iconH: require('@/static/CodeBuddyAssets/31266_3151/1h.svg'),
						icon: require('@/static/CodeBuddyAssets/31266_3151/1.svg'),
						route: '/userPageLab/userCenter',
						childRoutes: ['/userPageLab/userCenter']
					},
					{
						label: '快件下单',
						iconH: require('@/static/CodeBuddyAssets/31266_3151/2h.svg'),
						icon: require('@/static/CodeBuddyAssets/31266_3151/2.svg'),
						route: '/userPageLab/orderPage',
						childRoutes: ['/userPageLab/orderPage','/userPageLab/orderPageAddr', '/userPageLab/orderPageAddrMsg', '/userPageLab/orderPageAddrMsgPoin']
					},
					{
						label: '仓库',
						iconH: require('@/static/add2/66.png'),
						icon: require('@/static/add2/67.png'),
						route: '/userPageLab/selPackage',
						childRoutes: ['/userPageLab/selPackage']
					},
					{
						label: '集运订单',
						iconH: require('@/static/CodeBuddyAssets/31266_3151/3h.svg'),
						icon: require('@/static/CodeBuddyAssets/31266_3151/3.svg'),
						route: '/userPageLab/myOrderPage',
						childRoutes: ['/userPageLab/myOrderPage','/userPageLab/myOrderMsg', '/userPageLab/myOrderFreight','/userPageLab/myOrderPay']
					},
					{
						label: '我的包裹',
						iconH: require('@/static/add2/46.png'),
						icon: require('@/static/add2/45.png'),
						route: '/userPageLab/packageList',
						childRoutes: ['/userPageLab/packageList','/userPageLab/packageAdd', '/userPageLab/packageAddMore','/userPageLab/packageMsg']
					},
					{
						label: '代购订单',
						iconH: require('@/static/add2/48.png'),
						icon: require('@/static/add2/47.png'),
						route: '/userPageLab/myshopOrder',
						childRoutes: ['/userPageLab/myshopOrder','/userPageLab/myShopOrderMsg', '/userPageLab/myShopOrderReturn','/userPageLab/myShopPay']
					},
					{
						label: '优惠券',
						iconH: require('@/static/add2/54.png'),
						icon: require('@/static/add2/55.png'),
						route: '/userPageLab/myCoupon',
						childRoutes: ['/userPageLab/myCoupon']
					},
					{
						label: '我的收藏',
						iconH: require('@/static/add2/58.png'),
						icon: require('@/static/add2/59.png'),
						route: '/userPageLab/myCollect',
						childRoutes: ['/userPageLab/myCollect']
					},
					{
						label: '仓库地址查询',
						iconH: require('@/static/CodeBuddyAssets/31266_3151/6h.svg'),
						icon: require('@/static/CodeBuddyAssets/31266_3151/6.svg'),
						route: '/userPageLab/myPPoint'
					},
					{
						label: '消息通知',
						iconH: require('@/static/add2/63.png'),
						icon: require('@/static/add2/62.png'),
						route: '/userPageLab/myNews',
						childRoutes: ['/userPageLab/myNews']
					},
					{
						label: '个人资料',
						iconH: require('@/static/CodeBuddyAssets/31266_3151/8h.svg'),
						icon: require('@/static/CodeBuddyAssets/31266_3151/7.svg'),
						route: '/userPageLab/userProfile',
						childRoutes: ['/userPageLab/myAddr','/userPageLab/myAddrMsg', '/userPageLab/myAddrMsgMore','/userPageLab/myMarks']
					},
					{
						label: '常见问题',
						iconH: require('@/static/CodeBuddyAssets/31266_3151/8h.svg'),
						icon: require('@/static/CodeBuddyAssets/31266_3151/8.svg'),
						route: '/userPageLab/faq'
					},
					{
						label: '用户协议',
						iconH: require('@/static/CodeBuddyAssets/31266_3151/8h.svg'),
						icon: require('@/static/CodeBuddyAssets/31266_3151/10.svg'),
						route: '/userPageLab/xieyi'
					},
					{
						label: '退出登录',
						icon: require('@/static/CodeBuddyAssets/31266_3151/11.svg'),
						route: ''
					}
				]
			}
		},
		watch: {
			'$route.path': {
				handler() {
					this.initActiveIndex()
				}
			}
		},
		mounted() {
			this.initActiveIndex()
		},
		methods: {
			initActiveIndex() {
				const currentPath = this.$route.path
				// 优先精确匹配 route
				let findIndex = this.menuItems.findIndex(item => item.route === currentPath)
				// 精确匹配失败时，检查 childRoutes 子路由
				if (findIndex === -1) {
					findIndex = this.menuItems.findIndex(item =>
						item.childRoutes && item.childRoutes.includes(currentPath)
					)
				}
				if (findIndex !== -1) {
					this.menuItemsIdx = findIndex
				}
			},
			// 退出登录
			async handleLogout() {
				try {
					await this.$confirm(this.$t('confirmDialog.logoutMsg'), this.$t('confirmDialog.logoutTitle'), {
						confirmButtonText: this.$t('confirmDialog.confirmBtn'),
						cancelButtonText: this.$t('confirmDialog.cancelBtn'),
						type: 'warning'
					})
					this.$store.commit('userMsg/tokenC', '')
					this.$store.commit('userMsg/userInfoC', '')
					this.$router.push('/login')
				} catch (err) {
					if (err !== 'cancel') {
						console.error(this.$t('confirmDialog.logoutErr'), err)
					}
				}
			},
			handleMenuClick(item, index) {
				if(item.key==10){
					this.handleLogout()
					return
				}
				this.menuItemsIdx = index
				if (item.route && this.$route.path !== item.route) {
					if(item.route=='/userPageLab/orderPage'){
						this.$router.push({path:item.route,query:{clear:true}});
					}else{
						this.$router.push(item.route)
					}
				}
			},
			setActive(key, route) {
				this.activeMenu = key
				if (route && this.$route.path !== route) {
					this.$router.push(route)
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	/* ========== 侧边栏容器 ==========
   整体 Flex 纵向布局，无绝对定位 */
	.sidebar {
		width: 2.60rem;
		height: 14.04rem;
		display: flex;
		flex-direction: column;
		position: relative;
		overflow: hidden;

		/* ===== 背景层：纯色 + 图片叠加 ===== */
		.sidebar-bg-layer {
			position: absolute;
			inset: 0;
			z-index: 0;

			.sidebar-solid {
				width: 100%;
				height: 100%;
				background: #0096FF;
				border-top-right-radius: 0.62rem;
			}

			.sidebar-overlay {
				position: absolute;
				inset: 0;
				border-top-right-radius: 0.44rem;
			}
		}

		/* ===== 内容区：Flex 纵向流式布局 ===== */
		.sidebar-content {
			position: relative;
			z-index: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			padding-top: 0.40rem;
			flex: 1;
		}

		/* ===== Logo 区（Flex 水平居中）===== */
		.logo-area {
			flex-shrink: 0;
			// width: 0.95rem;
			// height: 0.65rem;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 0.16rem;

			.logo-base {
				// position: absolute;
				// width: 0.95rem;
				// height: 0.65rem;
				// background: #FFFFFF;
			}

			.logo-img {
				position: relative;
				width: 1.44rem;
				// height: 0.64rem;
				z-index: 1;
				// background: #fff;
				border-radius: 0.04rem;
			}
		}

		/* ===== 导航菜单（Flex 列表）===== */
		.menu-list {
			width: 100%;
			padding-left: 24px;

			.menu-item {
				width: 2.12rem;
				height: 0.50rem;
				border-radius: 10px;
				margin-bottom: 10px;
				padding-left: 20px;
				cursor: pointer;

				.menu-icon {
					width: 0.20rem;
					height: 0.20rem;
					margin-right: 12px;
				}

				.menu-text {
					font-size: 16px;
					color: #fff;
				}
			}

			.a {
				background: #fff;

				.menu-text {
					color: #0096FF;
				}
			}
		}
	}

	/* 减少动态偏好：禁用过渡动画 */
	@media (prefers-reduced-motion: reduce) {

		.sidebar .home-btn,
		.sidebar .menu-item,
		.sidebar .menu-item .active-bar,
		.sidebar .menu-item .menu-icon {
			transition: none !important;
		}
	}
</style>